
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 24.664a.63.63 0 01-.64-.639V7.385a.625.625 0 01.448-.601 36.319 36.319 0 016.502-1.421 35.009 35.009 0 016.49-.141.639.639 0 01.589.64v16.986a.587.587 0 01-.23.486.615.615 0 01-.512.153 27.512 27.512 0 00-6.323 0 26.679 26.679 0 00-6.157 1.19.614.614 0 01-.166-.013zm.64-16.832v15.36a31.51 31.51 0 015.619-.998 32.671 32.671 0 015.901 0V6.45a35.296 35.296 0 00-5.696.154 37.81 37.81 0 00-5.824 1.229zM16 24.664a.614.614 0 01-.218 0A26.877 26.877 0 009.6 23.435a27.512 27.512 0 00-6.323 0 .62.62 0 01-.512-.153.596.596 0 01-.23-.486V5.862a.636.636 0 01.412-.599.626.626 0 01.253-.041 35.037 35.037 0 016.541.115c2.21.276 4.391.752 6.515 1.421a.642.642 0 01.435.601v16.64a.63.63 0 01-.392.594.63.63 0 01-.247.045zm-9.51-2.65c.934 0 2.022 0 3.251.141a31.6 31.6 0 015.619.998V7.793a37.7 37.7 0 00-5.76-1.19 35.405 35.405 0 00-5.76-.154v15.68a25.485 25.485 0 012.65-.115zM16 26.878a1.582 1.582 0 01-1.28-.551H.64a.64.64 0 01-.64-.64V7.153a.64.64 0 01.64-.64h1.856a.64.64 0 110 1.28h-1.28v17.254h13.901a.628.628 0 01.589.423.338.338 0 00.295.128.757.757 0 01.755-.55h13.965V7.794h-1.216a.64.64 0 110-1.28h1.856a.64.64 0 01.64.64v18.534a.64.64 0 01-.64.64H17.153a1.374 1.374 0 01-1.152.551z"}})])
          )
        }
      }
    